import { render } from "./BaseToolTip.vue?vue&type=template&id=30dd2658&scoped=true"
import script from "./BaseToolTip.vue?vue&type=script&lang=js"
export * from "./BaseToolTip.vue?vue&type=script&lang=js"

import "./BaseToolTip.vue?vue&type=style&index=0&id=30dd2658&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dd2658"]])

export default __exports__